import i18next from 'i18next';

import { emsApi } from '@/api/emsApi';
import type { GeoPoint } from '@/signalr/contracts';

const cache = new Map<string, string>();

function currentTwoLetterLanguage(): string {
  const language = i18next.language || 'en';
  return language.split('-')[0] ?? 'en';
}

export async function reverseGeocode(geoPoint: GeoPoint): Promise<string> {
  const cacheKey = `${geoPoint.latitude};${geoPoint.longitude}`;
  const cached = cache.get(cacheKey);
  if (cached !== undefined) {
    return cached;
  }

  const { data, response } = await emsApi.POST('/portal/v1/geocoding/reverse', {
    body: {
      geoPoint: { latitude: geoPoint.latitude, longitude: geoPoint.longitude },
      language: currentTwoLetterLanguage(),
    },
    parseAs: 'text',
  });

  if (data === undefined) {
    throw new Error(`Reverse geocoding failed (HTTP ${response.status})`);
  }

  cache.set(cacheKey, data);
  return data;
}
